import { render, staticRenderFns } from "./ResetSuccessful.vue?vue&type=template&id=60786489"
import script from "./ResetSuccessful.vue?vue&type=script&lang=js"
export * from "./ResetSuccessful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports